import { Typography } from 'src/components/PulseUI';
import React from 'react';

const TrendVolumeHeader = (props) => {
  return (
    <Typography
      variant="body2"
      bold
      truncate
      className="w-full h-full flex items-center justify-end"
    >
      {props?.colDef?.headerName}
    </Typography>
  );
};

export default TrendVolumeHeader;
